export default __webpack_public_path__ + "static/monitor_b.83bd47a6973e57e4bb3bf55a2b82fe0b.png";